import {action, observable} from "mobx";
import {NoticeTypeEnum} from "../models/notice";
import {IOrderDto, IOrderRequestDto, IOrderResultDto} from "../models/order/order";
import BaseStore from "./base/base-store";
import RootStore from "./root-store";

export default class OrderStore extends BaseStore {
    private static setCookie(token: string) {
        const cookieKey = 'order-token=';
        document.cookie = `${cookieKey};expires=Thu, 01 Jan 1970 00:00:00 GMT`;
        document.cookie = `${cookieKey + token}`;
    }

    @observable
    public isCreating = false;

    @observable
    public isFetchingOrder = false;

    @observable
    public isFetchingOrderTotal = false;

    @observable
    public order: IOrderDto;

    constructor(rootStore: RootStore) {
        super(rootStore);
    }

    public async createOrder(request: IOrderRequestDto): Promise<string> {
        const rootStore = this.rootStore;

        try {
            this.startCreating();
            const result = await rootStore.orderApi.createOrder(request);

            if (result.data.valid) {
                const orderResult = result.data.result as IOrderResultDto;
                OrderStore.setCookie(orderResult.token);
                return orderResult.orderCode;
            } else {
                Object.values(result.data.errors).map((error) => {
                    this.notify(NoticeTypeEnum.Failure, error);
                });

                return null;
            }
        } catch (e) {
            this.notify(NoticeTypeEnum.Failure, e);
            return null;
        } finally {
            this.finishCreating();
        }
    }

    public async getOrderByCode(code: string) {
        try {
            this.startFetchingOrder();
            const result = await this.rootStore.orderApi.getOrderByCode(code);
            this.setOrder(result.data);
        } catch (e) {
            this.notify(NoticeTypeEnum.Failure, e);
        } finally {
            this.finishFetchingOrder();
        }
    }

    public async pay() {
        try {
            this.startFetchingOrderTotal();
            const result = await this.rootStore.orderApi.getOrderTotal(this.order.code);
            document.location.href = `${process.env.REACT_APP_MAKSEKESKUS_ENDPOINT}&amount=${result.data}&reference=${this.order.code}`;
        } catch (e) {
            this.notify(NoticeTypeEnum.Failure, e);
        } finally {
            this.finishFetchingOrderTotal();
        }
    }

    @action
    private setOrder(order: IOrderDto) {
        this.order = order;
    }

    @action
    private startCreating() {
        this.isCreating = true;
    }

    @action
    private finishCreating() {
        this.isCreating = false;
    }

    @action
    private startFetchingOrder() {
        this.isFetchingOrder = true;
    }

    @action
    private finishFetchingOrder() {
        this.isFetchingOrder = false;
    }

    @action
    private startFetchingOrderTotal() {
        this.isFetchingOrderTotal = true;
    }

    @action
    private finishFetchingOrderTotal() {
        this.isFetchingOrderTotal = false;
    }
}



// WEBPACK FOOTER //
// ./src/stores/order-store.ts